import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const CrmMainService = {
    crm_search_criteria,
    getAllSavedFilters,
    crm_search_execution,
    crm_update_block,
    deleteBlockById,
    crm_update_block_order,
    getAllStats,
    getBlockById,
    getAllReminders,
    crm_update_reminder
};


async function crm_search_criteria(newFilter) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newFilter),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/save-search`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllSavedFilters(
  node_mid,
  user_id,
  user_table_id,
  create_user_id,
  create_user_table_id
) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/getAll/saved-filters?node_mid=${node_mid}&user_id=${user_id}&user_table_id=${user_table_id}&create_user_id=${create_user_id}&create_user_table_id=${create_user_table_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function crm_search_execution(search_execution) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(search_execution),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/execution-search`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function crm_update_block(block_data) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(block_data),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/insert-edit`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function deleteBlockById(id) {
  const configOptions = {
    method: "DELETE",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/deleteBlockByBlock/${id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}


async function crm_update_block_order(block_data) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(block_data),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/update-order`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllStats(
  node_mid,
  user_id,
  user_table_id
) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/get-statistics/${node_mid}/${user_id}/${user_table_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getBlockById(
  block_id,
  trail_id
) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/get-block-by-id/${block_id}/${trail_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllReminders(
  node_mid,
  user_id,
  user_table_id,
) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/get-reminders/${node_mid}/${user_id}/${user_table_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function crm_update_reminder(reminder) {
  const configOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(reminder),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/crm-main/update-reminders`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}